import { FlightTripTypeMap } from "@/types/chat"
import { FlightOption } from "@/types/flights/flight-option"
import { Optional } from "@/types/util"
import { cn } from "cn"

import { Locale } from "@/lib/locale-hooks"

interface Option {
  best?: Optional<boolean>
  cheapest?: Optional<boolean>
  fastest?: Optional<boolean>
  trip_type: FlightOption["trip_type"]
  price: FlightOption["price"]
}

interface FlightOptionPriceProps {
  option: Option
}

export function FlightOptionPrice({ option }: FlightOptionPriceProps) {
  const formatFlightPrice = Locale.useFormatFlightPrice()

  function priceClass(option: Option): string {
    if (option.best) {
      return "text-sky-11"
    } else if (option.cheapest) {
      return "text-green-10"
    } else if (option.fastest) {
      return "text-plum-10"
    } else {
      return ""
    }
  }

  const isSingleTicket = option.price.total_per_ticket === option.price.total

  return (
    <div>
      <div className={cn("no-translate", "font-semibold", priceClass(option))}>
        {formatFlightPrice(
          option.price.total_per_ticket,
          option.price.currency
        )}
      </div>
      <div className="text-muted">
        {!isSingleTicket && (
          <>
            <div className="text-2xs">per person</div>
            <div className="text-xs font-semibold">
              <span className="no-translate">
                {formatFlightPrice(option.price.total, option.price.currency)}
              </span>{" "}
              total
            </div>
          </>
        )}
        {isSingleTicket && (
          <span className="lowercase">
            {FlightTripTypeMap[option.trip_type]}
          </span>
        )}
      </div>
    </div>
  )
}
